module.exports = "../../app/cells/components/trial/top_bar_cell.rb";